<a
  class="link-reset event-card-container"
  [routerLink]="['/agenda', event().id, event().startDate | date: 'dd-MM-yyyy', event().title | urlRewrite]"
>
  <article
    class="event-card"
    [class.event-card--list-item]="inList()"
    [ngClass]="'event-card--' + theme()"
    [class.is--past-event]="isPastEvent()"
  >
    <figure class="event-card__figure">
      @if (!event().videoUrl && event().image?.url && !hideImage()) {
        <img
          class="event-card__figure__media"
          [ngSrc]="event().image?.url || 'https://coda.fstr.io/media/placeholder.png'"
          [width]="800"
          [height]="800"
          [alt]="event().image?.alt || event().title"
          [loaderParams]="{
            width: 800,
            height: 800,
            anchor: event().image?.anchor || 'middlecenter',
            scale: 'both',
          }"
          [attr.data-object-position]="event().image?.anchor || 'middlecenter'"
          [priority]="priority()"
        />
      }
      @if (event().videoUrl) {
        <app-youtube
          class="event-card__figure__media"
          [url]="event().videoUrl!"
          [cookiePreferences]="cookiePreferences()"
          [previewOnly]="true"
          [color]="theme()"
        ></app-youtube>
      }
      <!--
      @if (isPastEvent()) {
        <div class="event-card__figure__overlay">
          <ul class="pe-3 pt-2">
            <li>
              <span class="badge text-bg-light">{{ 'event-label-geweest' | fromDictionary }}</span>
            </li>
          </ul>
        </div>
      }-->
    </figure>

    <div class="event-card__main-container">
      @if (hideImage()) {
        <h2 class="h2 max-lines-4 pb-2 text-dark px-2 px-md-3 card-title mb-2">{{ event().title }}</h2>
      }

      <main class="event-card__main">
        <div class="ps-2 py-1">
          @if (!hideImage()) {
            <h2 class="h5 fw-normal max-lines-3 mb-max-lines text-dark mb-0">{{ event().title }}</h2>
          }
          <span class="text-secondary d-block" [ngClass]="event().image?.url ? 'fs-body-xs' : 'fs-body-sm'">
            {{ event().startDate | eventDate: event().endDate }}
          </span>
        </div>
        <fstr-icon class="chip chip--secondary" anchor="icon-arrow-right"></fstr-icon>
      </main>
    </div>
  </article>
</a>
